module.exports = __webpack_public_path__ + "img/FI09003611.69d44d12.png";